<template>
  <div style="margin-top:24px">
    <h1 class="bigtitle">职业生涯</h1>
    <div class="lanmu fristitem">
      <ul class="news" >
        <li class="title">
          职业发展
          <router-link :to="`/news/views/${plateIdInfo}`"></router-link>
        </li>
        <div>
          <div class="list">
            <li v-for="(item,index) in ArrZJs.slice(0,5)" :key="index">
              <i class="iconfont icon-component-full2" style="    margin-right: 11px;"></i>
              <router-link :to="`/news/info/${item.plateid}/${item.uuid}`" :title="item.title">{{ item.title}}
              </router-link>
              <span>{{ item.addtime | datefilter }}</span>
            </li>
          </div>
          <!-- <div class="list" id="publishMain2"></div> -->
        </div>
      </ul>
    </div>
    <div class="lanmu seconditem">
      <ul class="news" >
        <li class="title">
          职业规划
          <router-link :to="`/news/views/${ghplateIdInfo}`"></router-link>
        </li>
        <div>
          <div class="list">
            <li v-for="(item,index) in ArrGuiHs.slice(0,5)" :key="index">
              <i class="iconfont icon-component-full2" style="    margin-right: 11px;"></i>
              <router-link :to="`/news/info/${item.plateid}/${item.uuid}`" :title="item.title">{{ item.title}}
              </router-link>
              <span>{{ item.addtime | datefilter }}</span>
            </li>
          </div>
          <!-- <div class="list" id="publishMain2"></div> -->
        </div>
      </ul>
    </div>
    <div class="thirditem">
      <div class="online" @click="$router.push($IsPhone?'/InqMember_M':'/InqMember')">
        <h1>会员查询</h1>
        <p>点击进入>></p>
      </div>
      <div class="queryinfo"  @click="$router.push($IsPhone?'/selectinq':'/selectinq')">
        <h1 style="color: #000">信息查询</h1>
        <p style="color: #000">点击进入>></p>
      </div>
    </div>
  </div>
</template>

<script>
import {getArticles} from '@/request/get'
import { IP_TEST } from '@/config'
export default {
  name: "EnvironmentService",
  components: {
  },
  data() {
    return {
      IP_TEST: IP_TEST,
      imgAd: [],
      ArrZJs:[],
      plateIdInfo:"",
      ghplateIdInfo:"",
      ArrGuiHs:[]
    }
  },
  created() {
    this.getArticles("职业发展");
    this.getguiHArticles("职业规划")
  },
  filters: {
    datefilter(value) {
      return value.slice(0,10);
    }
  },
  methods: {
     _sortByTop(arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].top == "1") {
          arr.unshift(arr[i]);
          arr.splice(i + 1, 1);
          break;
        }
      }
      return arr.slice(0,6);
    },
    async getArticles(platename) {
      let { plates } = this.$store.state;
      let list = plates.filter((item) => item.name == platename);
      let result_zj = await getArticles(list[0].uuid);
      this.plateIdInfo = list[0].uuid;
      result_zj = result_zj.data;
      this.ArrZJs = result_zj && this._sortByTop(result_zj);
    },
    async getguiHArticles(platename) {
      let { plates } = this.$store.state;
      let list = plates.filter((item) => item.name == platename);
      let result_zj = await getArticles(list[0].uuid);
      this.ghplateIdInfo = list[0].uuid;
      result_zj = result_zj.data;
      this.ArrGuiHs = result_zj && this._sortByTop(result_zj);
    }
  }
};
</script>
<style scoped>
.lanmu{
  width: 465px;
  height: 351px;
  background: #FFFFFF;
  position: relative;
  display: inline-flex;
  box-shadow: -1px 4px 16px 0px rgba(147,152,160,0.34);
}

.lanmu .news .title{
  font-size: 24px;
  
  font-weight: bold;
  color: #333333;
  line-height: 56px;
  height: 56px;
  padding-left: 44px;

  margin-bottom: 10px;
}
.lanmu .news .title a{
  position: absolute;
  padding-right: 25px;
  right: 8px;
  height: 56px;
  font-size: 14px;
  
  font-weight: 500;
  font-weight: normal;
  color: #999999;
  line-height: 56px;
  background: url(/static/img/gengduo1.png) no-repeat 12px 12px;
  background-position: center right;
}
.lanmu .news .list{
  padding-left:16px;
  padding-right:23px ;
}
.lanmu .news .list li{

  height: 50px;
  /* border-bottom: 1px solid #D9D9D9 ; */
  display: flex;
  justify-content: start;
  align-items: center;

}
.lanmu .news .list li:last-child{
  border-bottom:none;
}
.lanmu .news .list li a{
  
  line-height: 50px;
  font-size: 18px;
  width: 298px;
  
  font-weight: 400;
  color: #000000;
  -webkit-background-clip: text;
    word-break: break-all;
  -webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: block;
  cursor:pointer;
}

.lanmu .news .list li span {
  width: 97px;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  color: #999999;
  line-height: 44px;
  text-align: right;
  margin-left: 10px;
}
.lanmu .news .title{
  background: url(/static/img/title.png);
  
  background-position-y: 17px;
  background-position-x: 8px;
  background-color: #fff;
  width: 421px;
  background-repeat: no-repeat;
  color: #004FB7;
  border-top: 6px solid #0041BE;
  border-bottom: 1px solid #EFF1F4;
}
.seconditem {
  margin-left: 24px;
  position: relative;
    /* top: -186px; */
}
.thirditem{
  display: inline-block;
  width: 380px;
  height: 423px;
  position: absolute;
    margin-left: 36px;
}
.thirditem .online{
  background-image: url(/static/img/kaoshi.png);
  width: 313px;
  height: 163px;
  background-size: contain;
}
.thirditem .queryinfo{
  background-image: url(/static/img/chaxun.png);
  width: 311px;
  height: 163px;
  margin-top:27px;
  background-size: contain;
}
.thirditem h1{
  font-size: 31px;
  
  /* font-weight: bold; */
  color: #FFFFFF;
  /* line-height: 146px; */
  /* text-align: center; */
  position: relative;
    top: 47px;
    left: 140px;
    cursor:pointer;
}
.thirditem  p{
  font-size: 16px;
  color: #FFFFFF;
  position: relative;
    top: 66px;
    left: 140px;
    cursor:pointer;
}
.bigtitle {
  height: 34px;
  font-size: 36px;
  /* font-family: PingFang SC; */
  font-weight: bold;
  color: #004FB7;
  text-align: center;
  letter-spacing: 5px;
  margin-top: 45px;
  margin-bottom: 30px;
  background-image: url(/static/img/baito.png);
    background-repeat: no-repeat;
    background-position-y: 7px;
}
</style>
